import { compose } from 'redux';
import { connect } from 'react-redux';
import withAuth from '../../../common/WithAuth';
import LiveStreamDialog from '../../../pages/Admin/LiveStreamManagement/LiveStreamDialog';
import {
    UpdateDetailLiveStreamEventRequested,
    ClearUpdateDetailLiveStreamEvent,
    GetDetailLiveStreamEventRequested,
    ClearGetDetailLiveStreamEvent,
} from '../../../actions/LiveStreamManagement';

const mapStateToProps = (state) => ({
    detailLiveStream: state.livestream.getDetailLiveStream.data,
    detailLiveStreamErrors: state.livestream.getDetailLiveStream.errors,
    eventStartDate: state.eventManagement.infoEvent.data.sdate,
    eventEndDate: state.eventManagement.infoEvent.data.edate,
    updateLiveStreamSuccess: state.livestream.updateLiveStream.success,
    errors: state.livestream.updateLiveStream.errors,
    eventInfo: state.eventManagement.infoEvent.data,
});

const mapDispatchToProps = (dispatch) => ({
    fetchClearGetDetailLiveStream: () => {
        dispatch(ClearGetDetailLiveStreamEvent());
    },
    fetchGetDetailLiveStream: (params) => {
        dispatch(GetDetailLiveStreamEventRequested(params));
    },
    fetchClearUpdateDetailLiveStream: () => {
        dispatch(ClearUpdateDetailLiveStreamEvent());
    },
    fetchUpdateDetailLiveStream: (params) => {
        dispatch(UpdateDetailLiveStreamEventRequested(params));
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(LiveStreamDialog);
